<template>
  <Header class="main-header">
    <Menu mode="horizontal" theme="light" class="pro-menu">
      <Logo :class="'mobile'" />
      <h2 class="intro-title">{{ $t("home_of_investments") }}</h2>
      <div class="title_and_phone">
        <h1>{{ $t("companyName") }}</h1>
        <a class="number" :href="`tel:${$t('phone_number')}`">{{ $t("phone_number") }}</a>
      </div>
      <Drawer :title="$t('menu')" placement="right" :closable="true" v-model="show" class-name="menu-drawer">
        <Menu width="100%" :theme="'light'" :active-name="$route.path" class="header-menu">
          <SearchInput style="padding: 5px 15px" :onEnter="() => (show = !show)" />
          <MenuItem name="/services" to="/services" @click.native="show = false">
            <Icon type="ios-navigate"></Icon>
            {{ $t("services") }}
          </MenuItem>
          <MenuItem name="/partners" to="/partners" @click.native="show = false">
            <Icon type="ios-people"></Icon>
            {{ $t("partners") }}
          </MenuItem>
          <MenuItem name="/about" to="/about" @click.native="show = false">
            <Icon type="ios-information-circle" />
            {{ $t("aboutus") }}
          </MenuItem>
          <MenuItem name="/branches" to="/branches" @click.native="show = false">
            <Icon type="ios-pin" />
            {{ $t("branches") }}
          </MenuItem>
          <MenuItem name="/human-resources" to="/human-resources" @click.native="show = false">
            <Icon type="ios-briefcase"></Icon>
            {{ $t("human_resources") }}
          </MenuItem>
          <MenuItem name="/customer-care" to="/customer-care" @click.native="show = false">
            <Icon type="ios-call-outline" />
            {{ $t("customer_care") }}
          </MenuItem>
          <MenuItem name="/contact" to="/contact" @click.native="show = false">
            <Icon type="ios-contact" />
            {{ $t("contact") }}
          </MenuItem>
          <ApplyForLoan class="apply-mobile" />
        </Menu>
        <div class="buttons">
          <language-translators />
        </div>
      </Drawer>
      <div class="layout-nav">
        <MenuItem name="/services" to="/services">
          <Icon type="ios-navigate"></Icon>
          {{ $t("services") }}
        </MenuItem>
        <MenuItem name="/partners" to="/partners">
          <Icon type="ios-people"></Icon>
          {{ $t("partners") }}
        </MenuItem>
        <MenuItem name="/about" to="/about">
          <Icon type="ios-information-circle" />
          {{ $t("aboutus") }}
        </MenuItem>
        <MenuItem name="/branches" to="/branches" @click.native="show = false">
          <Icon type="ios-pin" />
          {{ $t("branches") }}
        </MenuItem>
        <MenuItem name="/human-resources" to="/human-resources">
          <Icon type="ios-briefcase"></Icon>
          {{ $t("human_resources") }}
        </MenuItem>
        <MenuItem name="/contact" to="/contact">
          <Icon type="ios-contact" />
          {{ $t("contact") }}
        </MenuItem>

        <MenuItem name="/customer-care" to="/customer-care" @click.native="show = false">
          <Icon type="ios-call-outline" /> {{ $t("customer_care") }}
        </MenuItem>
      </div>
      <div class="menu">
        <Button @click="show = !show" name="menu">
          <svg
            width="122px"
            height="50px"
            viewBox="0 0 122 50"
            version="1.1"
            xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <title>Untitled</title>
            <desc>Created with Sketch.</desc>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd">
              <g id="equal-mathematical-sign-svgrepo-com" fill="#000000">
                <path
                  d="M7.308,49.264 L114.496,49.264 C118.533,49.264
                121.805,45.993 121.805,41.954 C121.805,37.915 118.534,
                34.645 114.496,34.645 L7.308,34.645 C3.271,34.646 0,
                37.916 0,41.954 C0,45.992 3.271,49.264 7.308,49.264 Z"
                />
                <path
                  d="M7.308,15.158 L114.496,
                15.158 C118.533,15.158 121.805,11.886 121.805,7.849 C121.805,3.812 118.534,0.541
                114.496,0.541 L7.308,0.541
                C3.271,0.541 0,3.812 0,7.849
                  C0,11.886 3.271,15.158 7.308,15.158 Z"
                />
              </g>
            </g>
          </svg>
        </Button>
      </div>
    </Menu>
  </Header>
</template>
<script>
import LanguageTranslators from "./LanguageTranslators.vue";
import ApplyForLoan from "./ApplyForLoan.vue";
import Logo from "./Logo.vue";
import SearchInput from "./SearchInput.vue";

export default {
  components: {
    LanguageTranslators,
    Logo,
    SearchInput,
    ApplyForLoan,
  },
  data() {
    return {
      show: false,
    };
  },
};
</script>

<style lang="scss">
.main-header {
  margin: 0px 15px;
  border-radius: 0px 0px 4px 4px;
  border-width: 0px 1px 1px 1px;
  border-style: solid;
  border-color: #e8eaec;

  .title_and_phone {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-left: 10px;
    h1 {
      line-height: 1;
      font-size: 1.6em;
      color: #10a995;
    }
    .number {
      line-height: 1;
      text-align: center;
    }
  }
}
.logo.mobile {
  height: 50px;
  width: 50px;
  background-size: contain;
  border: unset;
}
.menu-drawer {
  .ivu-drawer-body {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 0;
    .buttons {
      display: flex;
      justify-content: center;
      align-items: center;
      padding: 10px;
      background-color: #f3f3f3;
      .links {
        margin-bottom: unset;
      }
    }
  }
}

.pro-menu.ivu-menu {
  margin: auto;
  display: flex;
  align-items: center;
  justify-content: space-between;
  &.ivu-menu-horizontal.ivu-menu-light:after {
    height: 0px;
  }
}
.intro-title {
  line-height: 3.3;
  font-size: 1.8em;
  color: dimgray;
}
.menu {
  display: none;
  height: 60px;
  line-height: 60px;
  svg {
    vertical-align: middle;
    width: 24px;
    height: 24px;
  }
}
.header-menu {
  .apply-mobile {
    margin: 20px auto auto auto;
    display: block;
  }
}
@media only screen and (max-width: 1250px) {
  .layout-nav {
    display: none;
  }
  .intro-title {
    display: none;
  }
  .menu {
    display: block;
  }
}
@media only screen and (min-width: 1250px) {
  .title_and_phone {
    display: none !important;
  }

  .logo.mobile {
    display: none;
  }
  .menu {
    margin-left: auto;
  }
}
</style>
